import axios from "axios";

const URL_API = "https://mindicador.cl/api/";
const URL_API_TICKET = process.env.VUE_APP_API_CONTENIDO;

export default {
  valores() {
    return axios.get(URL_API);
  },
  valoresBD() {
    return axios.get(URL_API_TICKET + `system/indicadores`);
  },
};
